let liveRegion: HTMLElement | null = null;

function getLiveRegion(): HTMLElement {
  if (!liveRegion || !liveRegion.isConnected) {
    liveRegion = document.createElement("div");
    liveRegion.setAttribute("aria-live", "polite");
    liveRegion.setAttribute("aria-atomic", "true");
    liveRegion.className = "sr-only";
    document.body.appendChild(liveRegion);
  }
  return liveRegion;
}

// Announce a short message to screen readers via a shared polite live region.
export function announce(message: string): void {
  getLiveRegion().textContent = message;
}

// Move keyboard focus to the first heading of a freshly rendered screen so
// screen-reader and keyboard users land at the top of the new content.
export function focusFirstHeading(container: HTMLElement): void {
  const heading = container.querySelector<HTMLElement>("h1, h2");
  if (!heading) return;
  heading.setAttribute("tabindex", "-1");
  heading.focus();
}
